import { Grid, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    getProjects
} from "../../store/actions";
import RegisterData from "./RegisterData";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        cardContent: {
            textAlign: "center",
        },
        text: { color: "black" },
    })
);
interface Props {
    getProjects: any;
    projects: any;

}
const StopsPlace: React.FC<Props> = ({
    getProjects,
    projects,

}) => {
    const history = useHistory();
    const timer = useRef<any>(0);
    const [subProject, setSubProject] = useState<any>(null);
    const [project, setProject] = useState<any>();
    const [subProjectId, setSubProjectId] = useState<any>();
    const showProjectSamples = async () => {
        if (subProject)
            setSubProjectId(subProject._id);
    }

    return (
        <Grid container spacing={2} style={{ marginTop: 10 }}>
            <Grid
                container
                spacing={1}
                direction="row"
                style={{ marginTop: 10 }}
            >

                <Grid item xs={12} sm={4} md={3}>
                    <Autocomplete
                        id="Project"
                        onChange={(event, newValue) => {
                            setProject(newValue);
                        }}
                        options={projects?.results || []}
                        blurOnSelect
                        getOptionLabel={(option: any) => {
                            return (
                                (option?.projectId) +
                                " " +
                                (option?.institute?.name || "") +
                                " " +
                                (option?.scientist?.name || "") +
                                "," +
                                (option?.dealer?.firmName || "")
                            );
                        }}
                        onInputChange={(event, newInputValue) => {
                            let data = newInputValue.split(" ");
                            clearTimeout(timer.current);
                            timer.current = setTimeout(() => {
                                if (data.length > 0) {
                                    getProjects(`?projectId=${data[0]}`);
                                }
                            }, 1000);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className="input"
                                label="Project ID"
                                placeholder="Search ID/Client/Dealer Name"
                                variant="outlined"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                    <Autocomplete
                        id="subProject_name"
                        onChange={(event, newValue) => {
                            setSubProject(newValue);
                        }}
                        options={project?.subProjects || []}
                        blurOnSelect
                        getOptionLabel={(option: any) => option.title}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className="input"
                                label="SubProject Name"
                                placeholder="Select Subproject Name"
                                variant="outlined"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => setSubProjectId(subProject?._id)}

                    >
                        Filter
                    </Button>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => history.go("/dashboard/gnrelab/project-samples")}
                    >
                        Reset
                    </Button>
                </Grid>
                {/* <Grid item xs={12} sm={4} md={2}>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() =>
                            history.push("/dashboard/gnrelab/sample_export")
                        }
                    >
                        Export
                    </Button>
                </Grid> */}
            </Grid>
            <RegisterData subProjectId={subProjectId} />
        </Grid>
    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,


});
export default connect(mapStateToProps, {
    getProjects,

})(StopsPlace);
